const BasicInfo = () => import('./pages/BasicInfo.vue')
const UsersList = () => import('./pages/UsersList.vue')
const UsersInvite = () => import('./pages/UsersInvite.vue')
const Api = () => import('./pages/Api.vue')
const Security = () => import('./pages/Security.vue')

const userRoutes = [
  {
    path: 'user/basic-info',
    name: 'basic-info',
    component: BasicInfo,
    meta: { requiresAuth: true, menuType: 'Profile' },
  },
  {
    path: 'user/security',
    name: 'user-security',
    component: Security,
    meta: { requiresAuth: true, menuType: 'Profile' },
  },
  {
    path: 'user/api',
    name: 'api-key',
    component: Api,
    meta: { requiresAuth: true, menuType: 'Profile' },
  },
  {
    path: 'users/list',
    name: 'users-list',
    component: UsersList,
    meta: { requiresAuth: true, menuType: 'Organization & Users' },
  },
  {
    path: 'users/invite',
    name: 'users-invite',
    component: UsersInvite,
    meta: { requiresAuth: true, menuType: 'Organization & Users' },
  },
  {
    path: 'users/editInvite',
    name: 'users-edit-invite',
    component: UsersInvite,
    meta: { requiresAuth: true, menuType: 'Organization & Users' },
  },
  {
    path: 'users/editUserOrganization',
    name: 'users-edit-user-organization',
    component: UsersInvite,
    meta: { requiresAuth: true, menuType: 'Organization & Users' },
  },
]

export default userRoutes
